import { render, staticRenderFns } from "./FormulaUploadForm.vue?vue&type=template&id=1dc8b423&"
import script from "./FormulaUploadForm.vue?vue&type=script&lang=js&"
export * from "./FormulaUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports